import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.805 11.805a.667.667 0 0 1-.943 0L3.529 8.47a.667.667 0 0 1 0-.942l3.333-3.334a.667.667 0 1 1 .943.943L4.943 8l2.862 2.862c.26.26.26.682 0 .943",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.667 8a.667.667 0 0 1-.667.667H4a.667.667 0 0 1 0-1.334h8c.368 0 .667.299.667.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })